import { tauriMode, isElectron } from '@/shared/utils/import-meta'

import { PLATFORM } from '.'

export const getPlatform = async (): Promise<PLATFORM> => {
  if (tauriMode()) {
    const { platform } = await import('@tauri-apps/plugin-os')
    const tauriPlatform = platform()
    if (tauriPlatform === 'android') {
      return PLATFORM.ANDROID
    } else if (tauriPlatform === 'windows') {
      return PLATFORM.WINDOWS
    } else if (tauriPlatform === 'ios') {
      return PLATFORM.IOS
    } else if (tauriPlatform === 'macos') {
      return PLATFORM.MACOS
    } else if (tauriPlatform === 'linux') {
      return PLATFORM.LINUX
    }
  }

  if (isElectron()) {
    const electronPlatform = await window.electronAPI?.getOS()
    if (electronPlatform === 'Windows') {
      return PLATFORM.WINDOWS
    } else if (electronPlatform === 'macOS') {
      return PLATFORM.MACOS
    } else if (electronPlatform === 'Linux') {
      return PLATFORM.LINUX
    }
  }

  return PLATFORM.WEB
}
